/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  StorageDownloadLinkResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    StorageDownloadLinkResponseDtoFromJSON,
    StorageDownloadLinkResponseDtoToJSON,
} from '../models/index';

export interface GetDownloadLinkRequest {
    blobName: string;
    isLegacyFile: boolean;
}

/**
 * 
 */
export class StorageApi extends runtime.BaseAPI {

    /**
     * Get download link
     */
    async getDownloadLinkRaw(requestParameters: GetDownloadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageDownloadLinkResponseDto>> {
        if (requestParameters['blobName'] == null) {
            throw new runtime.RequiredError(
                'blobName',
                'Required parameter "blobName" was null or undefined when calling getDownloadLink().'
            );
        }

        if (requestParameters['isLegacyFile'] == null) {
            throw new runtime.RequiredError(
                'isLegacyFile',
                'Required parameter "isLegacyFile" was null or undefined when calling getDownloadLink().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blobName'] != null) {
            queryParameters['blobName'] = requestParameters['blobName'];
        }

        if (requestParameters['isLegacyFile'] != null) {
            queryParameters['isLegacyFile'] = requestParameters['isLegacyFile'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/storage/download-link`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageDownloadLinkResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get download link
     */
    async getDownloadLink(requestParameters: GetDownloadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageDownloadLinkResponseDto> {
        const response = await this.getDownloadLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
